module.exports = __webpack_public_path__ + "img/price-tag-2-fill.79c5f128.svg";